// extracted by mini-css-extract-plugin
export default {"header":"Header_header__kasgQ","title":"Header_title__VpR8e","userMenuContainer":"Header_userMenuContainer__cjns6"};